import { theme as _theme } from "../../seenspire-library";

export const initialTheme = {
  ..._theme,
  layout: {
    ..._theme.layout,
    sidePadding: 40,
    gap: 20,
    gridColumnTemplate: "repeat(auto-fit, minmax(350px, 1fr))",
    customColors: {
      upgradeColor: {
        base: "#FEB454",
        dark: "#F9A941",
      },
    },
  },
};
